export class EditRangeTypePayload {
  name: string;
  useForSourceTaxJurisdiction: boolean;
  useForDestinationTaxJurisdiction: boolean;
  excluded: boolean;
}
